import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login')
        .then(m => m.Login),
  },

  {
    path: '',
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard')
            .then(m => m.Dashboard),
      },

      // -------------------------------------------------------
      // Kunden — admin, invoice und offer (beide Rollen legen Kunden an)
      // -------------------------------------------------------
      {
        path: 'customers',
        canActivate: [roleGuard(['admin', 'invoice', 'offer'])],
        loadComponent: () =>
          import('./features/customers/customers-overview/customers-overview')
            .then(m => m.CustomersOverview),
      },
      {
        path: 'customers/new',
        canActivate: [roleGuard(['admin', 'invoice', 'offer'])],
        loadComponent: () =>
          import('./features/customers/customer-detail/customer-detail')
            .then(m => m.CustomerDetail),
      },
      {
        path: 'customers/:id',
        canActivate: [roleGuard(['admin', 'invoice', 'offer'])],
        loadComponent: () =>
          import('./features/customers/customer-detail/customer-detail')
            .then(m => m.CustomerDetail),
      },

      // -------------------------------------------------------
      // Artikelstamm — Verwaltung nur Admin (Lesen für Dropdowns läuft über
      // die Services, nicht über diese Routen, siehe docs/api-contract.md)
      // -------------------------------------------------------
      {
        path: 'articles',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./features/articles/articles-overview/articles-overview')
            .then(m => m.ArticlesOverview),
      },
      {
        path: 'articles/new',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./features/articles/article-detail/article-detail')
            .then(m => m.ArticleDetail),
      },
      {
        path: 'articles/:id',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./features/articles/article-detail/article-detail')
            .then(m => m.ArticleDetail),
      },
      {
        path: 'article-categories',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./features/article-categories/article-categories-overview/article-categories-overview')
            .then(m => m.ArticleCategoriesOverview),
      },
      {
        path: 'units',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./features/units/units-overview/units-overview')
            .then(m => m.UnitsOverview),
      },

      // -------------------------------------------------------
      // Rechnungen — admin und invoice; offer hat KEINEN Zugriff
      // -------------------------------------------------------
      {
        path: 'invoices',
        canActivate: [roleGuard(['admin', 'invoice'])],
        loadComponent: () =>
          import('./features/invoices/invoice-list/invoice-list')
            .then(m => m.InvoiceListComponent),
      },
      {
        path: 'invoices/new',
        canActivate: [roleGuard(['admin', 'invoice'])],
        loadComponent: () =>
          import('./features/invoices/invoice-detail/invoice-detail')
            .then(m => m.InvoiceDetailComponent),
      },
      {
        path: 'invoices/:id',
        canActivate: [roleGuard(['admin', 'invoice'])],
        loadComponent: () =>
          import('./features/invoices/invoice-detail/invoice-detail')
            .then(m => m.InvoiceDetailComponent),
      },

      // -------------------------------------------------------
      // Angebote — admin und offer voll, invoice nur lesend (Read-only-
      // Darstellung in quote-detail selbst, siehe Rollen-Check dort)
      // -------------------------------------------------------
      {
        path: 'quotes',
        canActivate: [roleGuard(['admin', 'invoice', 'offer'])],
        loadComponent: () =>
          import('./features/quotes/quote-list/quote-list')
            .then(m => m.QuoteListComponent),
      },
      {
        path: 'quotes/new',
        canActivate: [roleGuard(['admin', 'offer'])],
        loadComponent: () =>
          import('./features/quotes/quote-detail/quote-detail')
            .then(m => m.QuoteDetailComponent),
      },
      {
        path: 'quotes/:id',
        canActivate: [roleGuard(['admin', 'invoice', 'offer'])],
        loadComponent: () =>
          import('./features/quotes/quote-detail/quote-detail')
            .then(m => m.QuoteDetailComponent),
      },

      // -------------------------------------------------------
      // Fallback
      // -------------------------------------------------------
      {
        path: '**',
        redirectTo: 'dashboard',
      },
    ],
  },
];
